import { Partner, PointOfSale, Region} from '@m4a3/api-client';
import {
  GET_PARTNERS_REQUEST,
  GET_PARTNERS_SUCCESS,
  GET_PARTNERS_FAILURE,
  GET_REGIONS_REQUEST,
  GET_REGIONS_SUCCESS,
  GET_REGIONS_FAILURE,
  GET_POINTOFSALE_REQUEST,
  GET_POINTOFSALE_SUCCESS,
  GET_POINTOFSALE_FAILURE,
  UPDATE_POINTOFSALE_REQUEST,
  UPDATE_POINTOFSALE_SUCCESS,
  UPDATE_POINTOFSALE_FAILURE,
  ADD_POINTOFSALE_REQUEST,
  ADD_POINTOFSALE_SUCCESS,
  ADD_POINTOFSALE_FAILURE,
  UPDATE_OPENING_HOURS_REQUEST,
  UPDATE_OPENING_HOURS_SUCCESS,
  UPDATE_OPENING_HOURS_FAILURE
} from 'actions/actionTypes';
import { AnyAction } from 'redux';

interface initialState {
  partners: Partner[],
  fetchingPartners: Boolean;
  regions: Region[],
  fetchingRegions: Boolean;
  pointOfSales: PointOfSale[],
  fetchingPointOfSales: Boolean;
  savingPointOfSale: boolean;
  savingOpeningHours: boolean;
  sendingBackOpenNotif: Boolean;
  backOpenPreferenceCount: number,
  fetchingBackOpenPreferenceCount: Boolean;
}
const defaultState: initialState = {
  partners: [],
  fetchingPartners: false,
  regions: [],
  fetchingRegions: false,
  pointOfSales: [],
  fetchingPointOfSales: false,
  savingPointOfSale: false,
  savingOpeningHours: false,
  sendingBackOpenNotif: false,
  backOpenPreferenceCount: 0,
  fetchingBackOpenPreferenceCount: true
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case GET_PARTNERS_REQUEST:{
      return {
        ...state,
        fetchingPartners: true
      }
    }
    case GET_PARTNERS_SUCCESS: {
      return {
        ...state,
        partners: action.payload,
        fetchingPartners: false
      }
    }
    case GET_PARTNERS_FAILURE: {
      return {
        ...state,
        fetchingPartners: false
      }
    }
    case GET_REGIONS_REQUEST:{
      return {
        ...state,
        fetchingRegions: true
      }
    }
    case GET_REGIONS_SUCCESS: {
      return {
        ...state,
        regions: action.payload,
        fetchingRegions: false
      }
    }
    case GET_REGIONS_FAILURE: {
      return {
        ...state,
        fetchingRegions: false
      }
    }
    case GET_POINTOFSALE_REQUEST: {
      return {
        ...state,
        fetchingPointOfSales: true,
      }
    }
    case GET_POINTOFSALE_SUCCESS: {
      return {
        ...state,
        pointOfSales: action.payload,
        fetchingPointOfSales: false
      }
    }
    case GET_POINTOFSALE_FAILURE: {
      return {
        ...state,
        fetchingPointOfSales: false
      }
    }
    case UPDATE_POINTOFSALE_REQUEST:
    case ADD_POINTOFSALE_REQUEST: {
      return {
        ...state,
        savingPointOfSale: true
      }
    }
    case UPDATE_POINTOFSALE_SUCCESS:
    case ADD_POINTOFSALE_SUCCESS:
    case UPDATE_POINTOFSALE_FAILURE:
    case ADD_POINTOFSALE_FAILURE: {
      return {
        ...state,
        savingPointOfSale: false
      }
    }
    case UPDATE_OPENING_HOURS_REQUEST: {
      return {
        ...state,
        savingOpeningHours: true
      }
    }
    case UPDATE_OPENING_HOURS_SUCCESS:
    case UPDATE_OPENING_HOURS_FAILURE: {
      return {
        ...state,
        savingOpeningHours: false
      }
    }
    default:
      return state;
    }
};
